import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import AppBreadCrumb from '../../common/AppBreadCrumb'

import { createPermission, fetchPermission, UpdatePermission} from '../../../api/milma_admin/PermissionsAPI';

import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter } from '../../../commonfunctions';

const PermissionsForm = (props) => {

  const {formType,currentPermissionId} = props;
  const navigate = useNavigate();

  const [currentPermission, setCurrentPermission] = useState(null);
  const [currentPermissionError, setCurrentPermissionError] = useState(null);

 
  const [showToaster, setShowToaster] = useState(false);
  const [toaster, setToaster] = useState({});



  const customStyles = {
    option: (provided, permission) => ({
      ...provided,
      color: 'black', // Set label color to black
      backgroundColor: permission.isFocused ? '#11a1fd' : 'white', // Blue on hover, white otherwise
      color: permission.isFocused ? 'white' : 'black', //White text on blue, black otherwise
      padding: '15',
    }),
    control: (provided) => ({
      ...provided,
      borderColor: 'rgba(98,98,98, 0.4)', // Optional: customize the border
    }),
    singleValue: (provided, Permission) => ({
      ...provided,
      textAlign: 'left', // Align the selected value text to the left
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0.5rem 0.5rem',
    }),

  };


  const saveAddPermissionForm = (exitForm) => {

    console.log("new Permission is", currentPermission);

    setCurrentPermissionError({});
    createPermission(currentPermission, function (response) {
      console.log("in createPermission", response);

      if ("permission" in response) {


        // setSaveCompleted(prevPermission => !prevPermission); // Toggle the Permission
        if (exitForm) {

          navigate('/general/permissions', {
            permission: { message: 'Permission saved successfully!' }
          });
        }
        else {
          setShowToaster(true);
          setToaster({ type: 'success', heading: 'Success', message: 'Permission Added Successfully' });
          setCurrentPermission(null);
        }
      }
      else {
        // Use the generic error handling function
        console.log("error Response", response);

        handleApiError(response, setCurrentPermissionError);
      }


    });

  }

  const handleResetPermissionForm = () =>{

      setCurrentPermission(null);
      setCurrentPermissionError(null);
  }

  const getTitle = () =>{

    console.log("formType",formType);
    
    if(formType == 'create')
    {
      return 'Create New Permission Wizard'
    }
    else
    {
      return 'Edit Permission Wizard'
    }
  }

  useEffect(() => {
    setCurrentPermission(null);

    if (formType != null && formType != 'create' && currentPermissionId) {

      fetchPermission(currentPermissionId, function (response) {
        console.log("in fetchPermission", response);

        if ("permission" in response) {
          
          setCurrentPermission(response.permission);
         


        }



      });
    }

  }, [formType, currentPermissionId]);


  const saveEditPermissionForm = (exitForm) => {


    setCurrentPermissionError(null);
    UpdatePermission(currentPermission, function (response) {
      console.log("in updatePermission", response);

      if ("permission" in response) {

        // setToaster({ type: 'success', heading: 'Success', message: 'Permission Updated Successfully' });
        // setShowToaster(true);
        navigate('/general/permissions', {
          permission: { message: 'Permission Updated successfully!' }
        });
       
      }
      else {
        // Use the generic error handling function
        handleApiError(response, setCurrentPermissionError);
      }


    });
  }

  return (
    <>
      <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster}></AppToaster>
      <main>
        <div className="container-fluid">
          {/* Breadcrumb start */}
          <AppBreadCrumb title= {getTitle()}>
             <li><a className="f-s-14 f-w-500" href="#">Admin</a></li>
            <li >
              <a className="f-s-14 f-w-500" href="#">Permissions</a>
            </li>
            <li className="active">
              <a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a>
            </li>
          </AppBreadCrumb>


          {/* Breadcrumb end */}
          {/* ready to use form start */}
          <div className="row">
            {/* Book Appointment Form start */}
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5>{formType=='create'?'Add New':'Edit'} Permission  {formType=='edit'?(':'+currentPermission?.name):''}</h5>
                </div>
                <div className="card-body">
                  <form className="app-form">
                    <div className="row">
                      
                      <div className="col-md-12">
                        <div >
                          <label className="form-label">Permission Name *</label>
                          <input className="form-control" placeholder="Enter Permission Name" value={currentPermission ? currentPermission.name : ''} onChange={(e) => setCurrentPermission({ ...currentPermission, name: e.target.value })} required type="text" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentPermissionError?.name}</span>
                        </div>
                      </div>
                    
                  
                      


                      <div className="col-12">
                        <div className="text-end">
                          {formType=='create'?(
                            <>
                            <button className="btn btn-outline-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveAddPermissionForm(0)}>Save + Next
                            <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                              <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                            </svg>


                          </button>
                          <button className="btn btn-primary me-2 btn-sm btn-md " type="button" onClick={() => saveAddPermissionForm(1)}>Save + Exit
                            <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                              <path d="M11 12H22M11 12L15 8M11 12L15 16" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                            </svg>


                          </button>
                          <button className="d-none d-md-inline-block btn btn-danger btn-sm btn-md btn-mobile-padding" onClick={handleResetPermissionForm} type="reset">Reset</button>
                          </>
                          ):(
                            <>
                            <button className="btn btn-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveEditPermissionForm(1)}> Update
                            <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                              <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                            </svg>


                          </button>
                            <button className="btn btn-danger me-2 btn-sm btn-md  " type="button" onClick={() => navigate('/general/permissions')}> Cancel
                            <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                              <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                            </svg>


                          </button>
                          </>
                          )}
                          
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Book Appointment Form end */}




          </div>
          {/* ready to use form and */}
        </div>
      </main>

    </>
  )
}

export default PermissionsForm
